import {useParams} from "react-router-dom";
import {useHashWizard} from "../../../../../common/components/wizards/useHashWizard";
import {useControllers} from "../../../../../../../common/helpers/react/hooks/useControllers";
import {asNumber} from "../../../../../../../common/helpers/converters/asNumber";
import GroupWizardStepTemplate from "../GroupWizardStepTemplate";
import GroupWizardApplicationStepFormPresenter from "./GroupWizardApplicationStepFormPresenter";

export default function GroupWizardApplicationStepPresenter() {
    const {id} = useParams();

    const wh = useHashWizard();

    const groups = useControllers().groups;
    const groupId = asNumber(id);
    const group = groups.getGroupById$(groupId).useState() ?? undefined;

    return (
        <GroupWizardStepTemplate wizardHelpers={wh} group={group}>
            <GroupWizardApplicationStepFormPresenter wizardHelpers={wh}/>
        </GroupWizardStepTemplate>
    );
}